import axios from 'axios';
import Cookies from 'js-cookie';

const restServer = localStorage.getItem('@CoreBlockchain:restServer');
let baseURL: string | null = '';

if (restServer && restServer !== '') {
  baseURL = restServer;
} else if (process.env.NODE_ENV === 'development') {
  baseURL = process.env.REACT_APP_BASE_URL || 'http://localhost';
} else if (process.env.NODE_ENV === 'production') {
  baseURL = `http://${Cookies.get('base_url') || 'localhost'}:80`;
}

const instance = axios.create({ baseURL });

// Função para aplicar o token de autenticação
const applyAuthToken = () => {
  const token = localStorage.getItem('@CoreBlockchain:authToken');
  if (token && token !== '' && token !== 'askForToken') {
    instance.defaults.headers.common.Authorization = token;
  } else {
    delete instance.defaults.headers.common.Authorization;
  }
};

// Aplicar token inicial
applyAuthToken();

// Interceptador para aplicar token em cada request
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('@CoreBlockchain:authToken');
  if (token && token !== '' && token !== 'askForToken') {
    config.headers.Authorization = token;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (typeof error.response !== 'undefined') {
      if (error.response.status === 401) {
        localStorage.setItem('@CoreBlockchain:authToken', 'askForToken');
      }
    }
    return Promise.reject(error);
  },
);

export { instance };
